import { render } from "./Loadings.vue?vue&type=template&id=2ccec914&scoped=true"
import script from "./Loadings.vue?vue&type=script&lang=js"
export * from "./Loadings.vue?vue&type=script&lang=js"

import "./Loadings.vue?vue&type=style&index=0&id=2ccec914&scoped=true&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ccec914"]])

export default __exports__